import InboxIcon from "@mui/icons-material/Inbox";
import { Stack, Typography } from "@mui/material";

interface ChatInboxEmptyStateProps {
  title: string;
  subtitle: string;
}

export function ChatInboxEmptyState(props: ChatInboxEmptyStateProps) {
  const { title, subtitle } = props;

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={{
        height: "100%",
        minHeight: 240,
        py: 6,
        px: 3,
        textAlign: "center",
      }}
    >
      <InboxIcon sx={{ fontSize: 40, color: "text.disabled" }} />
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {subtitle}
      </Typography>
    </Stack>
  );
}
